import React from "react";
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend
} from "recharts";
import BootstrapCard from 'shared/components/bootstrapCard/BootstrapCard';
import LinearProgress from 'material-ui/LinearProgress';
import CustomizedXAxisTick from "./CustomizedXAxisTick";
import CustomizedTooltip from "./CustomizedTooltip";
import { MONTHS } from 'shared/components/monthPicker/helpers/monthPickerConstants';

class VendorOverchargesChart extends React.Component {

  componentDidMount() {
    this.props.vendorsActions.fetchVendors();
  }

  legendPayload = (
    [
      {
        id: `calculatedTax`,
        value: `Sovos Tax`,
        type: "square",
        color: `#8884d8`
      },
      {
        id: `vendorTax`,
        value: `Vendor Tax`,
        type: "square",
        color: `#82ca9d`
      }
    ]
  );

  render() {
    const { vendors, fetchingVendors } = this.props;
    const date = new Date();
    return (
      <BootstrapCard 
        title={ `Vendor Summary Display - ${MONTHS[date.getMonth()]} ${date.getFullYear()}` }
        width={ '100%' }
        height={ 380 }
        margin={ '12px 0px 0px 0px' }
      >
        <div>
          {
            fetchingVendors &&
            <LinearProgress mode="indeterminate" />
          }
          {
            !fetchingVendors && vendors.length > 0 &&
            <ResponsiveContainer width="100%" height={ 350 }>
              <BarChart
                width={ 750 }
                height={ 330 }
                data={ vendors }
                margin={ { top: 5, right: 10, left: 0, bottom: 5 } }
              >
                <Tooltip
                  content={ <CustomizedTooltip /> }
                />
                <XAxis
                  dataKey="vendor"
                  width={ 750 }
                  interval={ 0 }
                  tick={
                    <CustomizedXAxisTick sibilings={ vendors.length }/>
                  }
                  tickLine={ false }
                  height={ 35 }
                />
                <YAxis />
                <Legend
                  verticalAlign="bottom"
                  payload={ this.legendPayload }
                />
                <Bar
                  dataKey="calculatedTax"
                  fill="#8884d8"
                />
                <Bar
                  dataKey="vendorTax"
                  fill="#82ca9d"
                />
              </BarChart>
            </ResponsiveContainer>
          }
          {
            !fetchingVendors && vendors.length <= 0 &&
            <div className="empty-chart-label">
              No overcharges for this period
            </div>
          }
        </div>
      </BootstrapCard>
    );
  }
}

VendorOverchargesChart.propTypes = {
  vendorsActions: PropTypes.shape({
    fetchVendors: PropTypes.func,
  }).isRequired,
  vendors: PropTypes.arrayOf(PropTypes.object),
  fetchingVendors: PropTypes.bool
};

VendorOverchargesChart.defaultProps = {
  fetchingVendors: false,
  vendors: []
};

export default VendorOverchargesChart;



// WEBPACK FOOTER //
// ./src/components/dashboard/comp/vendorOverchargesChart/VendorOverchargesChart.js